export const homePage = "homePage";
export const productPage = "productPage";
